import React from "react";

const Loader = () => {
  return (
    <>
      <div className="loader-div">
        <div className="loader-wrapper">
          <div className="loader-circle">
            <div></div>
            <div></div>
          </div>
        </div>
      </div>
    </>
  );
};

export default Loader;
